<app-header
  [enableLogout]="
    this.allLicenses?.length === 1 || this.kitLicenses?.length === 1
  "></app-header>

@if ((microphones$ | async)?.length > 1) {
  <app-microphone-bar
    [microphones]="microphones$ | async"
    class="microphone-bar" />
}
@if (poorAudioBanner(); as banner) {
  <app-information-banner class="audio-banner" [banner]="banner" (closeBanner)="dismissBanner()" (click)="openImproveAudioDialog()"></app-information-banner>
}
@if (translationsDisabledBanner(); as banner) {
  <app-information-banner class="translations-banner" [banner]="banner"></app-information-banner>
}
@if (translationsEnabledBanner(); as banner) {
  <app-information-banner class="translations-banner translations-enabled" [banner]="banner" (closeBanner)="translationsEnabledBanner.set(null)"></app-information-banner>
}
<div
  class="messages-wrapper"
  #scrollView
  appSpeechViewportWidth
  (scroll)="onWindowScroll()">
  <!-- TODO: Look into why this works -->
  <app-scroll-back-down-button
    [messageLength]="displayedMessages().length"
    (childScrollToBottom)="scrollToBottom()"
    [childIsAtBottom]="isAtBottom.bind(this)"></app-scroll-back-down-button>
  @if (!displayedMessages().length) {
    @if (session.type === 'microphonekit' && !isQRAuthMode) {
      <div class="speech-component__no-data">
        <div class="speech-component__no-data__content">
          <div class="speech-component__no-data__illustration">
            @if (isDarkMode$ | async) {
              <img src="assets/svg/hand_mic-dark-mode.svg" alt="Microphone device" width="350" height="350" />
            } @else {
              <img src="assets/svg/hand_mic.svg" alt="Microphone device" width="350" height="350" />
            }
          </div>
          
          <div class="speech-component__no-data__instructions">
            <h2 class="primary-instruction">{{ 'speech.turn_on_microphone' | transloco }}</h2>
            <p class="secondary-instruction">
              {{ 'speech.wait_for_green_light' | transloco }}<br />
              {{ 'speech.text_appears_when_connected' | transloco }}
            </p>
          </div>
        </div>
      </div>
    } @else {
      <div class="speech-component__no-data text-center">
        <span class="speech-component__no-data__text">
          <strong>{{ 'speech.no_messages' | transloco }}</strong>
          <br />
          {{ 'speech.waiting' | transloco }}
        </span>
        <div class="waiting-credit">
          <app-branding-logos [creditOnly]="true"></app-branding-logos>
        </div>
      </div>
    }
  }

  @for (message of displayedMessages(); track message.documentID; let i = $index) {
    <app-speech-bubble
      [message]="message"
      [prevTimestamp]="displayedMessages()[i - 1]?.updated_at">
    </app-speech-bubble>
  }
</div>
